import { getStore } from 'store/storeUtils';

export const useConnect = () => {
	const {loginData} = getStore()
	return {
		loginSuccess: loginData.loginSuccess,
	}
}
